import React, { FunctionComponent, useState } from 'react';
import ChannelOptionButton, { ChannelOptionButtonValues } from '../ChatbotUI/ChannelOptionButton';

import NewHotQuestion, { Question } from '../NewHotQuestion';
import Live from '../Live';

import './style.scss';
import { LiveComponentFromDialogueSource } from '../Live/constants';
import { TRACKING_TYPE } from '@/utils/constants';
import { ChatbotUIBasicProps } from '@/types/common';

interface Props {
  kbBotId: number;
  kbBotName: string;
  hasLiveAgent: boolean;
  categoryName: string;
  msgContent?: string;
  lastDialogueId?: string;
  hotQuestions: Array<Question>;
  liveButtonInfo: {
    btnContent: string;
    queue_name: string;
    buttonType: string;
  };
  channelButtonInfos: ChannelOptionButtonValues[];
  isHistory?: boolean;
  customCallback?: ChatbotUIBasicProps['customCallback'];
}

const LiveAgentRecommender: FunctionComponent<Props> = (props) => {
  const {
    kbBotId,
    kbBotName,
    msgContent,
    hotQuestions,
    hasLiveAgent,
    categoryName,
    liveButtonInfo,
    channelButtonInfos,
    lastDialogueId,
    ...otherProps
  } = props;
  const { customCallback = {} } = otherProps;

  return (
    <div className="live-agent-recommender">
      <NewHotQuestion
        msgContent={msgContent}
        categoryName={categoryName}
        hotQuestions={hotQuestions}
        hasLiveAgent={hasLiveAgent}
        lastDialogueId={lastDialogueId}
        isHistory={otherProps.isHistory}
        kbBotId={kbBotId}
        kbBotName={kbBotName}
        customCallback={customCallback}
      />
      <Live
        buttonClassName="live-button"
        {...liveButtonInfo}
        {...otherProps}
        disabledBtn={(props as any)?.disabledBtn}
        source={LiveComponentFromDialogueSource.LiveAgentRecommender}
        trackingname={TRACKING_TYPE.LIVE_AGENT_RECOMMENDER}
      />
      {props.channelButtonInfos.length !== 0 && <ChannelOptionButton
        buttons={channelButtonInfos}
        {...otherProps}
        trackingname={TRACKING_TYPE.LIVE_AGENT_RECOMMENDER}
        disabledBtn={(props as any)?.disabledBtn}
      />}
    </div>
  );
};

export default LiveAgentRecommender;
